import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ActiveAddressInAddressSelectorList from './ActiveAddressInAddressSelectorList'

import {Address} from '../models'

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {

  const confirmDelete = () => typeof window !== 'undefined' ? window.confirm("Are you sure you want to delete this address?") : false;

  return {
    onSelected: id => {
      ownProps.onSelected(id);
      dispatch(ownProps.selectAddressActionCreator(id));
    },
    onRadioSelected: id => {
      dispatch(ownProps.selectAddressActionCreator(id));
      ownProps.onRadioSelected(id);
    },
    onDelete: id => {
      if (confirmDelete()) {
        ownProps.onDeleted(id);
        dispatch(ownProps.deleteAddressActionCreator({addressId: id}));
      }
    }
  };
}

const AddressSelectorListActiveAddressContainer = connect(mapStateToProps, mapDispatchToProps)(ActiveAddressInAddressSelectorList)

AddressSelectorListActiveAddressContainer.propTypes = {
  address: PropTypes.shape(Address).isRequired,
  selectAddressActionCreator: PropTypes.func.isRequired,
  deleteAddressActionCreator: PropTypes.func.isRequired,
  onBeginEdit: PropTypes.func.isRequired,
  selectAddressMessage: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onDeleted: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  onRadioSelected: PropTypes.func.isRequired
}

export default AddressSelectorListActiveAddressContainer